import { useMutation } from 'react-query';
import { httpService } from '../../services/http.service';
import { BASE_URL } from '../../constants/endpoints';
import { IServerErrorResponse } from '../../types';
import { flattenServerErrorResponse } from '../../helpers/errors.helper';

interface IProps {
  customerId: string;
}

interface ChangePasswordRequestBody {
  existingPassword: string;
  newPassword: string;
}

export const useChangePasswordMutation = (
  { customerId }: IProps,
  onSuccess: (response: any) => void,
  onError: (error: any) => void,
) => useMutation(
  'changePassword',
  async ({ existingPassword, newPassword }: ChangePasswordRequestBody) => {
    const { data } = await httpService.post(
      `${BASE_URL}/api/v1/user/${customerId}/changePassword`,
      { existingPassword, newPassword },
    );
    return data;
  },
  {
    onSuccess,
    onError: (error: IServerErrorResponse) => {
      onError(flattenServerErrorResponse(error));
    },
  },
);
